import React, { useMemo, useState } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import { Drawer, Dropdown, Button, message, Image } from "antd";
import { UserOutlined, MenuOutlined, HomeOutlined } from "@ant-design/icons";
import { Auth } from "@components";
import { userLoaded, useAppDispatch, useCompany, useUser } from "@redux";
import { getIsVkSession, serverFetch, useGetIsPhone } from "@extensions";
import "./nav-menu.css";

const icon = require("@assets/sport_logo.png");
const getItem = (label, key) => ({ key, label });

const NavMenu = () => {
  const user = useUser();
  const company = useCompany();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [showSignin, setShowSignin] = React.useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isVkSession = getIsVkSession();
  const isPhone = useGetIsPhone();

  const divMain = isPhone ? <HomeOutlined /> : <div>ГЛАВНАЯ</div>;

  const navItems = useMemo(() => {
    const items = [
      getItem(<Link to="/home">{divMain}</Link>, "home"),
      getItem(<Link to="/catalog">УСЛУГИ</Link>, "catalog"),
    ];
      items.push(getItem(<Link to="/sched">РАСПИСАНИЕ</Link>, "sched"));
      items.push(getItem(<Link to="/sales">ПОКУПКИ</Link>, "sales"));
      items.push(getItem(<Link to="/history">ИСТОРИЯ</Link>, "history"));
    return items;
  }, [company, divMain, isVkSession, user]);

  const renderLinks = (onLinkClick) => {
    const linksData = [
      { to: "/home", label: "Главная" },
      { to: "/catalog", label: "Услуги" },
      { to: "/sched", label: "Расписание" },
      { to: "/sales", label: "Покупки" },
      { to: "/history", label: "История" },
    ];

    return linksData.map((link) => (
      <NavLink key={link.to} to={link.to} onClick={onLinkClick}
        className={({ isActive }) => 
          isActive ? "nav-link-item active" : "nav-link-item"
        }
      >
        {link.label}
      </NavLink>
    ));
  };

  const renderCompanyContacts = (className = "") => {
    if (!company?.phone && !company?.address) return null;

    return (
      <div className={`nav-company-contacts ${className}`}>
        {company?.phone && (
          <div className="nav-company-phone">
            {company.phone}
          </div>
        )}
        {company?.address && (
          <div className="nav-company-address">
            {company.address}
          </div>
        )}
      </div>
    );
  };

  const logout = () =>
    serverFetch(`auth/clientlogout`, { method: "PUT" }, user)
      .then(() => dispatch(userLoaded()))
      .catch(() => message.error("Ошибка выхода из системы"));

    const userMenuItems = [
      {
        key: "1",
        label: (<Button type="link" className="account-item-btn" onClick={() => navigate("/account")} size="middle">Мои данные</Button>),
      },
    ];

    if (!isVkSession)
        userMenuItems.push({
      key: "2",
      label: (<Button type="link" className="account-item-btn" onClick={logout} size="middle">Выход</Button>),
    });
    
//     return (
//         <>
//       <div className="nav-menu-container">
//         <Menu className="nav-menu" key="menu" mode="horizontal" theme="light" disabledOverflow items={navItems} />
//         <>
//           {user ? (
//           <Dropdown menu={{ items }} placement="bottomRight">
//             <div className="account-btn nav-menu-account-btn">
//               <UserOutlined />
//               <span>{isPhone || user.userName || user.userLogin}</span>
//             </div>
//           </Dropdown>
//           ) : (isVkSession || (<Button type="link" className="account-btn" onClick={() => setShowSignin(true)} size="middle" icon={<LockOutlined />}>{useGetIsPhone || "Личный кабинет"}</Button>))}
//         </>
//       </div>
//       {showSignin && (<Auth open={showSignin} onClose={() => setShowSignin(false)} />)}
//         </>
//     );
// };

  return (
    <>
      <div className="nav-menu-wrapper">
        <div className="nav-menu-container">
          <div className="nav-logo">
            <div className="logo-icon">
              <div className="header-logo">
                <Link to="/home">
                  <div className="header-image-container">
                    <Image src={company?.pictureFileName ? (process.env.REACT_APP_API_BASE_URL + "/api/image/" + company.pictureFileName) : icon}  preview={false} />
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <nav className="nav-links-desktop">
            {renderLinks()}
          </nav>

          <div className="nav-actions-right">
            {renderCompanyContacts("nav-company-contacts-desktop")}
            <div className="nav-auth">
              {user ? (
                <Dropdown menu={{ items: userMenuItems }} trigger={["click"]} placement="bottomRight">
                  <Button type="primary" className="nav-btn-login" icon={<UserOutlined />}>
                    <span className="nav-btn-login-text">{user.name || "Кабинет"}</span>
                  </Button>
                </Dropdown>
              ) : (
                !isVkSession && (
                  <Button type="primary" className="nav-btn-login" onClick={() => setShowSignin(true)}> Вход </Button>
                )
              )}
            </div>
            <Button type="text" className="nav-mobile-burger" icon={<MenuOutlined />}  onClick={() => setDrawerOpen(true)}/>
          </div>
        </div>
      </div>

      {/* Мобильное выезжающее меню */}
      <Drawer title="Навигация" placement="right" onClose={() => setDrawerOpen(false)} open={drawerOpen} width={280}>
        <nav className="nav-links-mobile">
          {renderLinks(() => setDrawerOpen(false))}
        </nav>
        {renderCompanyContacts("nav-company-contacts-mobile")}
      </Drawer>

      {showSignin && <Auth onClose={() => setShowSignin(false)} />}
    </>
  );
};

export default NavMenu;
